import { AxiosError } from "axios";
import { axios } from "../config/axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import {
  ICreateEsimZoneRequest,
  IEsimZone,
  IEsimZoneDetail,
  IEsimZoneNetworkOptions,
  IEsimZoneSaveResult,
  IUpdateEsimZoneRequest
} from "../interfaces/esim/EsimZone.types";

export const getEsimZones = async (): Promise<IAxiosResponse<IEsimZone[]>> => axios.get("v1/EsimZone/Zones");

// Zones are created in production only: every environment shares the production OCS reseller,
// which has no zone delete.
export const getEsimZoneCanCreate = async (): Promise<IAxiosResponse<boolean>> => axios.get("v1/EsimZone/CanCreate");

export const getEsimZoneNetworkOptions = async (
  countryIds: number[]
): Promise<IAxiosResponse<IEsimZoneNetworkOptions>> =>
  axios.get(`v1/EsimZone/NetworkOptions?countryIds=${countryIds.join(",")}`);

// A refusal (400, 409, 502) still carries the outcome in the envelope's data: the form needs the refused
// networks or the zone that already exists, so both calls resolve with the result instead of throwing.
const saveResult = async (
  request: Promise<IAxiosResponse<IEsimZoneSaveResult>>
): Promise<IEsimZoneSaveResult> => {
  try {
    return (await request).data;
  } catch (error) {
    const body = (error as AxiosError<{ data?: IEsimZoneSaveResult; message?: string }>).response?.data;
    if (body?.data) return body.data;
    throw error;
  }
};

export const createEsimZone = (body: ICreateEsimZoneRequest): Promise<IEsimZoneSaveResult> =>
  saveResult(axios.post("v1/EsimZone/Create", body));

export const getEsimZone = async (id: number): Promise<IAxiosResponse<IEsimZoneDetail>> =>
  axios.get(`v1/EsimZone/Zones/${id}`);

export const updateEsimZone = (id: number, body: IUpdateEsimZoneRequest): Promise<IEsimZoneSaveResult> =>
  saveResult(axios.put(`v1/EsimZone/Zones/${id}`, body));
